import { styled as MuiStyled } from "@mui/system";
import { TextField } from "@mui/material";

export const CustomTextField = MuiStyled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#f58220",
    },
    "&:hover fieldset": {
      borderColor: "#e4711f",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#f58220",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#000",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#000",
  },
  "& .MuiOutlinedInput-input": {
    color: "#000",
  },
});
